import { takeEvery } from "redux-saga/effects";

import {
  login,
  getConverters,
  addConverter,
  addNConverters,
  addMdl_V7Converter,
  copyConverter,
  removeConverter,
  updateConverterType,
  updateConverterMultipleMdl,
  updateConverterId,
  updateConverterOrder,
  setConfigConverter,
} from "../actions/actions";

import { getConverterConfig, setConfigParam, removeConfigParam } from "../actions/actions";
import {
  GetConverters,
  AddConverter,
  AddNConverters,
  AddMdl_V7Converter,
  UpdateConverterOrder,
  CopyConverter,
  RemoveConverter,
  UpdateConverterType,
  UpdateConverterMultipleMdl,
  UpdateConverterId,
  SetConfigConverter,
  GetConverterConfig,
  SetConfigParam,
  RemoveConfigParam,
} from "./converters";

export default function* conversionsFlow() {
  yield takeEvery(login, GetConverters);
  yield takeEvery(getConverters, GetConverters);
  yield takeEvery(addConverter, AddConverter);
  yield takeEvery(addNConverters, AddNConverters);
  yield takeEvery(addMdl_V7Converter, AddMdl_V7Converter);
  yield takeEvery(copyConverter, CopyConverter);
  yield takeEvery(removeConverter, RemoveConverter);
  yield takeEvery(updateConverterType, UpdateConverterType);
  yield takeEvery(updateConverterOrder, UpdateConverterOrder);
  yield takeEvery(updateConverterMultipleMdl, UpdateConverterMultipleMdl);
  yield takeEvery(updateConverterId, UpdateConverterId);

  yield takeEvery(getConverterConfig, GetConverterConfig);
  yield takeEvery(setConfigParam, SetConfigParam);
  yield takeEvery(removeConfigParam, RemoveConfigParam);
  yield takeEvery(setConfigConverter, SetConfigConverter);
}
